<template>
  <v-card
    class="mx-auto reports"
    tile>
    <v-row justify="start" align="start">
      <v-col cols="3" class="d-print-none">
        <v-list dense>
          <v-subheader>Reports</v-subheader>
          <v-list-item-group
            v-model="selectedItem"
            color="primary">
            <template v-for="(item, i) in items">
              <v-list-item
                v-on:click="setSelectedItem(item)"
                v-if="isInRole(item.roles)"
                :key="i">
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col cols="9">
        <component v-bind:is="reportComponent"></component>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import roleConstants from '@/roleConstants';
import storeConstants from '@/store/storeConstants';
import ByDateSuburb from '@/components/reports/ByDateSuburb.vue';
import DailyBooking from '@/components/reports/DailyBooking.vue';
import MonthlyRevenue from '@/components/reports/MonthlyRevenue.vue';
import AccountBookings from '@/components/reports/AccountBookings.vue';
import DailyCreditCard from '@/components/reports/DailyCreditCard.vue';
import CustomerInvoice from '@/components/reports/CustInvoice.vue';
import DriverPayIn from '@/components/reports/DriverPayIn.vue';
import RevenueByBus from '@/components/reports/RevenueByBus.vue';
import CustomerUsage from '@/components/reports/CustomerUsage.vue';

export default {
  name: 'Reports',
  data: () => ({
    reportComponent: null,
    selectedItem: null,
    items: [
      {
        text: 'By suburb/date', icon: 'mdi-map-clock-outline', roles: [roleConstants.SYSTEM_ADMINISTRATOR], component: ByDateSuburb,
      },
      {
        text: 'Daily booking', icon: 'mdi-account', roles: [roleConstants.SYSTEM_ADMINISTRATOR], component: DailyBooking,
      },
      {
        text: 'Monthly revenue', icon: 'mdi-cash-multiple', roles: [roleConstants.SYSTEM_ADMINISTRATOR], component: MonthlyRevenue,
      },
      {
        text: 'Account bookings', icon: 'mdi-inbox-arrow-down', roles: [roleConstants.SYSTEM_ADMINISTRATOR], component: AccountBookings,
      },
      {
        text: 'Daily credit card', icon: 'mdi-credit-card-multiple', roles: [roleConstants.SYSTEM_ADMINISTRATOR], component: DailyCreditCard,
      },
      {
        text: 'Customer invoice', icon: 'mdi-folder-account-outline', roles: [roleConstants.SYSTEM_ADMINISTRATOR], component: CustomerInvoice,
      },
      {
        text: 'Driver pay in', icon: 'mdi-account-arrow-left-outline', roles: [roleConstants.SYSTEM_ADMINISTRATOR, roleConstants.CONTRACT_DRIVER], component: DriverPayIn,
      },
      {
        text: 'Revenue by bus', icon: 'mdi-bus', roles: [roleConstants.SYSTEM_ADMINISTRATOR], component: RevenueByBus,
      },
      {
        text: 'Customer usage', icon: 'mdi-account-arrow-right-outline', roles: [roleConstants.SYSTEM_ADMINISTRATOR], component: CustomerUsage,
      },
    ],
  }),
  methods: {
    setSelectedItem(item) {
      this.reportComponent = item.component;
    },
    isInRole(roles) {
      if (!roles || roles.length === 0) {
        return true;
      }

      const found = roles.some(r => this.USER_ROLES.indexOf(r) >= 0);
      return found;
    },
  },
  computed: {
    ...mapGetters([
      storeConstants.LOADING,
      storeConstants.LOADING_TEXT,
      storeConstants.USER_ROLES]),
  },
  mounted() {
    // find the first report available to the current user
    this.items.forEach((item) => {
      if (this.isInRole(item.roles)) {
        this.reportComponent = item.component;
      }
    });

    const defaultReport = this.items.find(item => this.isInRole(item.roles));
    this.reportComponent = defaultReport?.component;
  },
};
</script>
<style>
  .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td,
  .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td,
  .v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 24px;
  }
  .v-data-table__empty-wrapper {
    visibility: collapse;
  }
  .reports .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .reports .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
  .reports .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .reports .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
  .reports .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
  .reports .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th
  {
    padding: 0 8px;
  }
</style>
